import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'First Name is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Last Name is required.' }
      ]
    },
    addressLine1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Email is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email address.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Phone is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    clientName: {
      validations: []
    },
    notes: {
      validations: []
    },
    accountExtra6: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    accountExtra7: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    accountExtra8: {
      validations: []
    },
    category: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'addressLine1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'city'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State',
            options: [
              { label: 'Alabama', value:'AL' },
              { label: 'Alaska', value:'AK' },
              { label: 'Arizona', value:'AZ' },
              { label: 'Arkansas', value:'AR' },
              { label: 'California', value:'CA' },
              { label: 'Colorado', value:'CO' },
              { label: 'Connecticut', value:'CT' },
              { label: 'Delaware', value:'DE' },
              { label: 'District of Columbia', value:'DC' },
              { label: 'Florida', value:'FL' },
              { label: 'Georgia', value:'GA' },
              { label: 'Hawaii', value:'HI' },
              { label: 'Idaho', value:'ID' },
              { label: 'Illinois', value:'IL' },
              { label: 'Indiana', value:'IN' },
              { label: 'Iowa', value:'IA' },
              { label: 'Kansas', value:'KS' },
              { label: 'Kentucky', value:'KY' },
              { label: 'Louisiana', value:'LA' },
              { label: 'Maine', value:'ME' },
              { label: 'Maryland', value:'MD' },
              { label: 'Massachusetts', value:'MA' },
              { label: 'Michigan', value:'MI' },
              { label: 'Minnesota', value:'MN' },
              { label: 'Mississippi', value:'MS' },
              { label: 'Missouri', value:'MO' },
              { label: 'Montana', value:'MT' },
              { label: 'Nebraska', value:'NE' },
              { label: 'Nevada', value:'NV' },
              { label: 'New Hampshire', value:'NH' },
              { label: 'New Jersey', value:'NJ' },
              { label: 'New Mexico', value:'NM' },
              { label: 'New York', value:'NY' },
              { label: 'North Carolina', value:'NC' },
              { label: 'North Dakota', value:'ND' },
              { label: 'Ohio', value:'OH' },
              { label: 'Oklahoma', value:'OK' },
              { label: 'Oregon', value:'OR' },
              { label: 'Pennsylvania', value:'PA' },
              { label: 'Rhode Island', value:'RI' },
              { label: 'South Carolina', value:'SC' },
              { label: 'South Dakota', value:'SD' },
              { label: 'Tennessee', value:'TN' },
              { label: 'Texas', value:'TX' },
              { label: 'Utah', value:'UT' },
              { label: 'Vermont', value:'VT' },
              { label: 'Virginia', value:'VA' },
              { label: 'Washington', value:'WA' },
              { label: 'West Virginia', value:'WV' },
              { label: 'Wisconsin', value:'WI' },
              { label: 'Wyoming', value:'WY' }
            ],
            mapping: 'state'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zipcode',
            mapping: 'postal'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company',
            mapping: 'clientName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments',
            mapping: 'notes'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'First Date Choice',
            mapping: 'accountExtra6'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Second Date Choice',
            mapping: 'accountExtra7'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests',
            mapping: 'accountExtra8'
          },
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'submit'
          },
        ]
      }
    ]
  },
  info: {
    title: 'Steele Hill Conferences Form',
    formId: '520',
    clientKey: 'D4B90153-5C38-48EC-9ECD-C1286B2DFC50',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://steelehillresorts.com/conferences/conferences-contact-form-success/',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/steelehillresorts2/form_structure.js